import { MatterRowContextMenu } from "@/components/features/matters/MatterRowContextMenu";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { CASE_MATTER_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import type { RecentMatter } from "@/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState, type ReactNode } from "react";

type RecentMatterRowContextMenuProps = {
  recentMatter: RecentMatter;
  trigger: ReactNode;
};

export function RecentMatterRowContextMenu({
  recentMatter,
  trigger,
}: RecentMatterRowContextMenuProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { data: matterData } = useQuery({
    ...retrieveMatterQueryOptions(recentMatter.id),
    enabled: isMenuOpen,
  });
  const matter = useMemo(() => {
    const detailedMatter = matterData?.data;

    return {
      attorneyFee: detailedMatter?.attorneyFee ?? null,
      dateModified: detailedMatter?.dateModified ?? recentMatter.dateModified,
      emailAddress: detailedMatter?.emailAddress ?? null,
      id: recentMatter.id,
      status: detailedMatter?.status
        ? {
            id: detailedMatter.status.id,
            label: detailedMatter.status.label,
          }
        : recentMatter.status,
      statusId: detailedMatter?.statusId ?? recentMatter.status.id,
      title: detailedMatter?.title ?? recentMatter.title,
    };
  }, [matterData?.data, recentMatter]);

  return (
    <MatterRowContextMenu
      allowedStatusCategories={CASE_MATTER_STATUS_CATEGORY_OPTIONS}
      matter={matter}
      trigger={trigger}
      onOpenChange={setIsMenuOpen}
    />
  );
}
